const config = {
  contract: 'https://participe.votolegal.com.br/files/Termo%20de%20uso%20e%20Politica%20de%20privacidade%20(unificado)%20-%20Voto%20Legal%20-%202020%402020-09-23.pdf',
  taxes: {
    CREDIT_CARD_TEXT: '5,5%',
    PAYMENT_SLIP_TEXT: '3,5% + R$ 3,90',
    PAYMENT_PIX_TEXT: '2,99%',
    CREDIT_CARD_TAX_PERCENT: 0.055,
    PAYMENT_SLIP_TAX_PERCENT: 0.035,
    PAYMENT_PIX_PERCENT: 0.0299,
    CREDIT_CARD_TAX: 0,
    PAYMENT_SLIP_TAX: 299,
  }
};

module.exports = config;



// WEBPACK FOOTER //
// ./_source/config.js